import { useState, useRef, useCallback } from 'react';

export type SaveStatus = 'idle' | 'saving' | 'saved';

export function useSaveIndicator(fadeOutDelay = 1500) {
    const [status, setStatus] = useState<SaveStatus>('idle');
    const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    const trigger = useCallback(() => {
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        setStatus('saving');
    }, []);

    const resolve = useCallback(() => {
        setStatus('saved');
        timeoutRef.current = setTimeout(() => {
            setStatus('idle');
        }, fadeOutDelay);
    }, [fadeOutDelay]);

    // A rejected save must not show "Saved": drop the indicator instead.
    const fail = useCallback(() => {
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        setStatus('idle');
    }, []);

    return { status, trigger, resolve, fail };
}
